import React, { useState } from "react";
import ctl from "@netlify/classnames-template-literals";

import { Button, Ntext } from "components";

import NoSpammingBadge from "svgs/blog/no-spamming.svg";

const BlogPageHero = () => {
  const [emailAddress, setEmailAddress] = useState("");

  return (
    <section className="flex flex-col items-center pt-12 pb-20 w-full">
      <Ntext
        color="n-grey0"
        value="Welcome To Nomba Blog"
        className="uppercase !text-[12px] !leading-[24px] !font-bold !tracking-[0.24em]"
        variant="p"
      />
      <Ntext
        color="n-grey8"
        value="What do you want to read today?"
        className="!text-[40px] !font-bold !leading-[48px] !-tracking-[2px] text-center mt-2"
        variant="h2"
      />
      <section className="mt-6 flex items-center justify-center relative">
        <article className="bg-[#ffffff] w-full rounded-lg max-w-[480px] shadow-[0px_4px_4px_-2px_#18274B14,_0px_2px_4px_-2px_#18274B1F]">
          <input
            onChange={event => setEmailAddress(event.target.value)}
            placeholder="Enter your email"
            defaultValue={emailAddress}
            type="text"
            className="py-5 px-6 w-full text-[16px] leading-[24px] text-[#808080]"
          />
        </article>
        <article className="relative mt-8 md:mt-0 -ml-40 md:ml-5">
          <Button
            href="#"
            className="!font-semibold !text-[14px] !min-w-[148px] !h-16"
            text="Subscribe"
            size="small"
          />
          <NoSpammingBadge className="absolute -right-[150px] -top-[45px]" />
        </article>
      </section>
    </section>
  );
};

export { BlogPageHero };
